export default __webpack_public_path__ + "static/media/team3.b3b1a616.png";